import { focusDeepWithin } from "@otto-ec/otto-components-utils/utils/focus/focusDeepWithin";
import { getNextParentElement } from "../../../common/utils/getNextParentElement";

/**
 *
 *
 *
 *
 *
 */
export function focusNextElement(element?: HTMLElement | null): boolean {
  if (!element) return false;

  const nextElement = element.nextElementSibling;
  if (!(nextElement instanceof HTMLElement)) {
    /*                                                          */
    return focusNextElement(getNextParentElement(element));
  }

  return focusDeepWithin(nextElement) || focusNextElement(nextElement);
}
